import React from 'react';

const LoginFooter = ({ className = '' }) => {
  const currentYear = new Date()?.getFullYear();

  const footerLinks = [
    { label: 'Privacy Policy', href: '#' },
    { label: 'Terms of Service', href: '#' },
    { label: 'Help Center', href: '#' }
  ];

  return (
    <footer className={`text-center space-y-4 ${className}`}>
      {/* Links */}
      <div className="flex flex-wrap justify-center items-center space-x-6 text-sm">
        {footerLinks?.map((link, index) => (
          <a
            key={index}
            href={link?.href}
            className="text-text-secondary hover:text-primary transition-micro"
          >
            {link?.label}
          </a>
        ))}
      </div>
      {/* Copyright */}
      <div className="text-xs text-text-secondary">
        <p>© {currentYear} ContactSync Pro. All rights reserved.</p>
        <p className="mt-1">Secure login with end-to-end encryption</p>
      </div>
      {/* Trust Indicators */}
      <div className="flex justify-center items-center space-x-4 pt-2">
        <div className="flex items-center space-x-1 text-xs text-text-secondary">
          <div className="w-2 h-2 bg-success rounded-full"></div>
          <span>SSL Secured</span>
        </div>
        <div className="flex items-center space-x-1 text-xs text-text-secondary">
          <div className="w-2 h-2 bg-success rounded-full"></div>
          <span>GDPR Compliant</span>
        </div>
      </div>
    </footer>
  );
};

export default LoginFooter;